import { Component, ViewEncapsulation } from "@angular/core";

@Component({
  selector: 'pl-scout-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: [ './side-bar.component.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class ScoutSideBarComponent { }
